import {query} from "@solidjs/router";
import api from "~/api/api";
import {getUser} from "~/api/auth";
import {InvoiceResponse, InvoiceListResponse} from "@tag-tails/types";

export const getInvoices = query(async (): Promise<InvoiceResponse[] | null | undefined> => {
    "use server"
    const user = await getUser()
    if (user) {
        try {
            const res = await api.get<InvoiceListResponse>(`/invoices/user/${user.id}`)
            return res.data.invoices as InvoiceResponse[]
        } catch {
            return null
        }
    }
    return undefined
}, "invoices")

export const getInvoice = query(async (id: string): Promise<InvoiceResponse | null | undefined> => {
    "use server"
    const user = await getUser()
    if (user) {
        try {
            const res = await api.get<InvoiceResponse>(`/invoices/${id}`)
            return res.data
        } catch {
            return null
        }
    }
    return undefined
}, "invoice")
